module.exports = __webpack_public_path__ + "img/e952d6668c1a94dcf75aa2ed43296842.png";